import { useState } from "react";
import { testimonials } from "@/mocks/homeData";

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = testimonials[currentIndex];

  const next = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="w-full bg-[#F7F5F2] py-20 md:py-28 lg:py-36">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">

        <p
          className="text-[11px] uppercase tracking-[0.22em] text-[#6C7278] mb-14 md:mb-20"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Client Success Stories
        </p>

        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">

          {/* Image */}
          <div className="w-full lg:w-[38%] flex-shrink-0">
            <div
              className="relative overflow-hidden aspect-[4/5] max-w-[380px] mx-auto lg:mx-0"
              style={{ borderRadius: "8px" }}
            >
              <img
                src={current.image}
                alt={current.name}
                className="w-full h-full object-cover transition-opacity duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 border border-[#1A1C1E]/10" style={{ borderRadius: "8px" }} />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 flex flex-col justify-between">
            <div>
              <h2
                className="text-2xl md:text-3xl lg:text-[40px] font-extrabold text-[#1A1C1E] leading-[1.1] tracking-[-0.02em]"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                Partnerships That
                <br />
                <span className="text-[#6C7278] font-light">Drive Real Results</span>
              </h2>

              <div className="mt-10 md:mt-14 relative pl-5 border-l-2 border-[#B8422E]">
                <p
                  className="text-base md:text-lg text-[#1A1C1E]/70 leading-relaxed"
                  style={{ fontFamily: "'Public Sans', sans-serif", fontStyle: "italic" }}
                >
                  {current.quote}
                </p>
              </div>

              <div className="mt-8">
                <p
                  className="text-sm font-semibold text-[#1A1C1E]"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {current.name}
                </p>
                <p
                  className="text-xs text-[#6C7278] mt-1"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  {current.title}
                </p>
              </div>
            </div>

            <div className="mt-10 flex items-center gap-3">
              <button
                onClick={prev}
                className="w-11 h-11 flex items-center justify-center border border-[#1A1C1E]/20 text-[#6C7278] hover:border-[#1A1C1E] hover:text-[#1A1C1E] transition-all duration-300"
                style={{ borderRadius: "4px" }}
                aria-label="Previous"
              >
                <i className="ri-arrow-left-line text-sm" />
              </button>
              <button
                onClick={next}
                className="w-11 h-11 flex items-center justify-center bg-[#1A1C1E] text-white hover:bg-[#B8422E] transition-colors duration-300"
                style={{ borderRadius: "4px" }}
                aria-label="Next"
              >
                <i className="ri-arrow-right-line text-sm" />
              </button>
              <div className="flex items-center gap-2 ml-2">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentIndex(i)}
                    className={`h-1 rounded-full transition-all duration-300 ${
                      i === currentIndex ? "w-8 bg-[#B8422E]" : "w-2 bg-[#1A1C1E]/20 hover:bg-[#1A1C1E]/40"
                    }`}
                    aria-label={`Go to ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
